import Bloc from './Bloc.js';
import Types from './Types.js';

export default class GainMaxHp extends Bloc {

	constructor (src, ctx) {

		super("gainmaxhp", src, ctx, true);
		this.f = (src, ins) => {
			src.master.run.champion.gainMaxHp(ins[0]);
			return [];
		};
		this.types = [Types.int];
	}
}